/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ForceOptionComponentEnum, PoDialogService, PoDynamicFieldType, PoModalComponent,
  PoNotification, PoNotificationService
} from '@po-ui/ng-components';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { Seller } from 'src/app/shared/interfaces/seller.model';
import { LiteralsService } from 'src/app/shared/services/literals-service';
import { TypesOfOperationService } from 'src/app/shared/services/types-of-operation.service';
import { ParameterService } from './../../shared/services/parameters.service';
import { SellersService } from './../../shared/services/sellers.service';
import { SetupSyncService } from './../../shared/services/setup-sync.service';
import { CustomFieldsService } from 'src/app/shared/services/custom-fields.service';
import { MingleService } from '@totvs/mingle';
import { take } from 'rxjs';
import { PdfCustomService } from '../../shared/services/pdf-custom/pdf-custom.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { IframeSecurityService } from 'src/app/shared/services/iframe-security.service';
import { SchemaFieldsService } from '../../shared/services/schema-fields.service';
import { Functions } from 'src/app/shared/functions/functions';

@Component({
  selector: 'tgv-loading-po-sync',
  standalone: false,
  templateUrl: './loading-po-sync.component.html',
  styleUrls: ['./loading-po-sync.component.css']
})
export class LoadingPoSyncComponent implements OnInit {
  @ViewChild('detailsModal', { static: true }) detailsModal: PoModalComponent;

  classText = 'message-main  message-show';
  literals: LiteralsWords;
  message = '';
  refreshText = 0;
  poNotificationModel: PoNotification;
  errorMessage: string;
  isNavigateToHomeRoute = false;
  isFullDataLoadSyncNotification = false;
  versionDecimals = '1.11.11'

  constructor(
    public poDialog: PoDialogService,
    private setupSyncService: SetupSyncService,
    private router: Router,
    private literalsService: LiteralsService,
    private sellerService: SellersService,
    private typeOfOperationService: TypesOfOperationService,
    private activatedRoute: ActivatedRoute,
    private parameterService: ParameterService,
    private poNotification: PoNotificationService,
    private customFieldsService: CustomFieldsService,
    private mingleService: MingleService,
    private pdfCustomService: PdfCustomService,
    private loginService: LoginService,
    private iframeSecurityService: IframeSecurityService,
    private schemaFieldsService: SchemaFieldsService,
    private functions: Functions
  ) {
    this.literals = this.literalsService.getLiteralModule();
  }

  ngOnInit(): void {
    this.message = `${this.literals.str0028} ${this.literals.str0026}...`;
    this.poNotificationModel = {
      message: '',
      actionLabel: this.literals.str0061,
      action: this.openModal.bind(this)
    };

    this.loadInitialData();
  }

  openModal(): void {
    this.detailsModal.open();
  }

  loadInitialData(): void {
    if (this.isReloadData()) {
      this.destroySyncAndLoadData();
    } else {
      this.changeUser();
    }

    this.loadCustomFieldsToStorage();
    this.loadTypesOfOperationToStorage();
    this.parameterService.setStorageParameter('MV_TESSAI', response => response);
    this.parameterService.setStorageParameter('MV_PAISLOC', response => response);
    this.parameterService.setStorageParameter('MV_PGVCSLD', response =>
      response ? response.trim().toUpperCase() === '.T.' : false
    );
    this.parameterService.setStorageParameter('MV_PGVTPOP', response => (response ? response.trim() : ''));
    this.parameterService.setStorageParameter('MV_ORCLIPD', response => response);
    this.parameterService.setStorageParameter('MV_PGVLFLD', response => response);
    this.parameterService.setStorageParameter('MV_APICCGC', response => response);
    this.setFinancialSheetAvailable();
    this.startSetInterval();
    this.setLogoDefaultPDF();
    this.setParamFieldsDecimals();
    this.setParamArreFat();
  }

  setFinancialSheetAvailable(): void {
    this.parameterService.getParameter('MV_GVPLFIN')
      .pipe(take(1))
      .subscribe(
        {
          next: response => {
            localStorage.setItem('MV_GVPLFIN_CRUD', response.value[0].parameterValue?.split(',')[0]);
            localStorage.setItem('MV_GVPLFIN_PDF', response.value[0].parameterValue?.split(',')[1]);
          },
          error: () => {
            localStorage.setItem('MV_GVPLFIN_CRUD', '2');
            localStorage.setItem('MV_GVPLFIN_PDF', '2');
          }
        });
  }

  isReloadData(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'carga/reloadBranch/:company/:branch';
  }

  startSetInterval(): NodeJS.Timeout {
    return setInterval(() => {
      if (this.classText === 'message-main message-hide') {
        this.message = `${this.literals.str0122}...`;
      }

      if (this.refreshText % 2) {
        this.classText = 'message-main message-show';
      } else {
        this.classText = 'message-main message-hide';
      }
      this.refreshText++;
    }, 2500);
  }

  changeUser(): void {
    if (localStorage.getItem('lastLogin') && localStorage.getItem('user')) {
      if (localStorage.getItem('user') !== localStorage.getItem('lastLogin')) {
        this.confirmChangeUser();
      } else {
        this.destroySyncAndLoadData();
      }
    } else {
      this.destroySyncAndLoadData();
    }
  }

  confirmChangeUser(): void {
    this.poDialog.confirm({
      literals: {
        cancel: this.literals.str0034,
        confirm: this.literals.str0123
      },
      title: this.literals.str0124,
      message: this.literals.str0125,
      confirm: this.changeSeller.bind(this),
      cancel: this.goToLogin.bind(this)
    });
  }

  goToLogin(): void {
    this.router.navigate(['login']);
  }

  destroySyncAndLoadData(): void {
    this.setupSyncService.destroySync().then(async () => {
      await this.setupSyncService.prepareSync();
      this.setupSyncService
        .loadDataControllSync()
        .then(() => this.navigateToHomeRoute())
        .catch(error => this.navigateToFailedLoginRoute(error));
    });
    setTimeout(() => this.navigateToHomeRoute(), 30000);
  }

  navigateToHomeRoute(): void {
    this.setToLocalStorageUserTheLastUserLogged();
    this.syncNotification();
    if (!this.isNavigateToHomeRoute) {
      this.isNavigateToHomeRoute = true;
      this.changeRouteToMainPage();
    }
  }

  syncNotification(): void {
    if (localStorage.getItem('errorLoadData') !== 'true') {
      if (!this.setupSyncService.isFullDataLoadSync) {
        this.poNotification.warning(this.literals.str0557); //'Sincronizando dados, por favor aguarde...'
      } else if (!this.isFullDataLoadSyncNotification) {
        this.isFullDataLoadSyncNotification = true;
        this.poNotification.success(this.literals.str0556); //'Sincronismo concluído'
      }
    }
  }

  navigateToFailedLoginRoute(error = { message: '' }): void {
    this.poNotificationModel.message = this.literals.str0484; // Falha ao realizar carga inicial de dados.
    this.errorMessage = error.message;
    this.poNotification.error(this.poNotificationModel);
    this.setupSyncService.disableSync();
    localStorage.removeItem('user');
    this.router.navigate(['login']);
  }

  clearStorageFilterByPriceList(): void {
    localStorage.removeItem('filterByPriceList');
  }

  setToLocalStorageUserTheLastUserLogged(): void {
    localStorage.setItem('lastLogin', localStorage.getItem('user'));
  }

  changeRouteToMainPage(): void {
    if (this.parameterService.isError) {
      this.loginService.logoutAuth();
    } else {
      if (this.iframeSecurityService.isInsideAllowedIframe()) {
        this.iframeSecurityService.sendCustomMessage({ action: 'RESYNC' });
      } else {
        this.router.navigate(['']);
      }
    }
  }

  startSync(): void {
    this.setupSyncService.startSync().then(() => {
      this.setToLocalStorageUserTheLastUserLogged();
      this.changeRouteToMainPage();
    });
  }

  async changeSeller(): Promise<void> {
    await this.sellerService.changeSeller().then(sellers => {
      this.canSellerAccess(sellers.items[0]);
    });
  }

  loadTypesOfOperationToStorage(): void {
    this.typeOfOperationService.setStorage();
  }

  loadCustomFieldsToStorage(): void {
    this.customFieldsService.getCustomFields().then(res => {
      res.items.forEach(item => {
        item.fields = item.fields.filter(field => {
          for (const value in PoDynamicFieldType) {
            if (field?.forceOptionsComponentType === 'ForceOptionComponentEnum.select' || value === field.type) {
              return true;
            }
          }
          return false;
        });
        item.fields.forEach(field => {
          if (field.forceOptionsComponentType === 'ForceOptionComponentEnum.select') {
            field.forceOptionsComponentType = ForceOptionComponentEnum.select;
          }
        });
        this.customFieldsService.setCustomFieldsOnStorage(item.schema, item.fields);
        this.addDeviceMetricToMingle(item.schema, item.fields);
      });
    }).catch(() => '');
  }

  canSellerAccess(seller: Seller): void {
    if (this.sellerService.canSellerAccess(seller)) {
      this.destroySyncAndLoadData();
      this.clearStorageFilterByPriceList();
    } else {
      this.router.navigate(['login']);
      this.sellerService.removeSeller();
    }
  }

  addDeviceMetricToMingle(schemaId = '', fields = []): void {
    if (fields.length > 0) {
      this.mingleService.registerMetric('PGV-CUSTOMFIELDS', { schemaid: schemaId });
    }
  }

  setLogoDefaultPDF(): void {
    this.parameterService.getParameter('MV_PGVLOGO')
      .pipe(take(1))
      .subscribe(
        {
          next: response => {
            if (response.systemparameterid === 'MV_PGVLOGO') {
              this.pdfCustomService.imageUrlIsValid(response.value[0].parameterValue?.split(',')[0])
                .then(isValid => {
                  if (!isValid) {
                    localStorage.setItem('MV_PGVLOGO', '');
                  } else {
                    localStorage.setItem('MV_PGVLOGO', response.value[0].parameterValue?.split(',')[0]);
                  }
                });
            } else {
              localStorage.setItem('MV_PGVLOGO', 'nonExistent');
            }
          },
          error: () => {
            localStorage.setItem('MV_PGVLOGO', 'nonExistent');
          }
        });
  }

  setParamFieldsDecimals(): void {
    if (this.functions.checkVersion(this.versionDecimals)) {
      this.parameterService.getParameter('MV_PGVDECI')
      .pipe(take(1))
      .subscribe(
        {
          next: response => {
            if (response.value[0].parameterValue === '.T.') {
              localStorage.setItem('MV_PGVDECI', 'true');
              this.setFieldsDecimals();
            }
          }
        }
      );
    }
  }

  setFieldsDecimals(): void {
    this.schemaFieldsService.getFieldsDecimals().then(fieldsDecimals => {
      localStorage.setItem('fieldsDecimals', JSON.stringify(fieldsDecimals));
    });
  }

  setParamArreFat(): void {
    if (this.functions.checkVersion(this.versionDecimals)) {
      this.parameterService.getParameter('MV_ARREFAT')
      .pipe(take(1))
      .subscribe(
        {
          next: response => {
            localStorage.setItem('MV_ARREFAT', response?.value[0]?.parameterValue.trim());
          }
        }
      );
    }
  }
}
